import { RuntimeConfig, SPFxAdalClient } from "@pnp/common";
export function setup(config) {
    RuntimeConfig.assign(config);
}
var GraphRuntimeConfigImpl = /** @class */ (function () {
    function GraphRuntimeConfigImpl() {
    }
    Object.defineProperty(GraphRuntimeConfigImpl.prototype, "headers", {
        get: function () {
            var graphPart = RuntimeConfig.get("graph");
            if (graphPart !== undefined && graphPart.headers !== undefined) {
                return graphPart.headers;
            }
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphRuntimeConfigImpl.prototype, "baseUrl", {
        get: function () {
            var graphPart = RuntimeConfig.get("graph");
            if (graphPart !== undefined && graphPart.baseUrl !== undefined) {
                return graphPart.baseUrl;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphRuntimeConfigImpl.prototype, "fetchClientFactory", {
        get: function () {
            var graphPart = RuntimeConfig.get("graph");
            // use a configured factory firt
            if (graphPart !== undefined && graphPart.fetchClientFactory !== undefined) {
                return graphPart.fetchClientFactory;
            }
            // then try and use spfx context if available
            if (RuntimeConfig.spfxContext !== undefined) {
                return function () { return new SPFxAdalClient(RuntimeConfig.spfxContext); };
            }
            throw Error("There is no Graph Client available, either set one using configuraiton or provide a valid SPFx Context using setup.");
        },
        enumerable: false,
        configurable: true
    });
    return GraphRuntimeConfigImpl;
}());
export { GraphRuntimeConfigImpl };
export var GraphRuntimeConfig = new GraphRuntimeConfigImpl();
//# sourceMappingURL=graphlibconfig.js.map